module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Войти":"Login","Решения для бизнеса":"Business solutions","Частным лицам":"Individuals","Тарифы":"Fees","Новости":"News","Контакты":"Contacts"}}')
  delete Component.options._Ctor
}
